var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportToExcel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67431 0.84081C2.11512 0.399992 2.713 0.152344 3.33641 0.152344H8.82107C9.02888 0.152344 9.22817 0.234893 9.37511 0.381832L14.8598 5.8665C15.0067 6.01344 15.0893 6.21273 15.0893 6.42053V9.6901H13.5222V6.74508L8.49653 1.71939H3.33641C3.12861 1.71939 2.92931 1.80194 2.78238 1.94888C2.63544 2.09582 2.55289 2.29511 2.55289 2.50291V15.0393C2.55289 15.2471 2.63544 15.4464 2.78238 15.5933C2.92931 15.7403 3.12861 15.8228 3.33641 15.8228H8.17852L9.12296 17.3899H3.33641C2.713 17.3899 2.11512 17.1422 1.67431 16.7014C1.23349 16.2606 0.98584 15.6627 0.98584 15.0393V2.50291C0.98584 1.8795 1.23349 1.28163 1.67431 0.84081Z",
    fill: "#23235F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0893 15.0393C15.0893 15.6627 14.8416 16.2606 14.4008 16.7014C13.96 17.1422 13.3621 17.3899 12.7387 17.3899H12.6448L11.4032 15.8228H12.7387H13.5222V15.0393H15.0893Z",
    fill: "#23235F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2895 15.8555C13.857 15.8555 13.5631 15.8555 13.5197 15.8542L13.5197 12.2439C13.8863 12.2439 13.8656 12.2439 14.2981 12.2439C14.7306 12.2439 14.7008 12.2439 15.0859 12.2439L15.0859 15.8542C14.9717 15.8528 14.7221 15.8555 14.2895 15.8555Z",
    fill: "#23235F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26753 13.8555L8.07553 12.0955L7.05153 13.8555H5.48353L7.29153 10.9435L5.42753 8.19947H7.05153L8.21153 9.90347L9.21153 8.19947H10.7715L8.98753 11.0475L10.8915 13.8555H9.26753Z",
    fill: "#23235F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4957 1.705L13.5433 6.72357L8.49404 6.72542L8.4957 1.705Z",
    fill: "#23235F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3029 19.4922L11.3988 15.8164L17.207 15.8164L14.3029 19.4922Z",
    fill: "#23235F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportToExcel);
export default __webpack_public_path__ + "static/media/ExportToExcel.5bf28d75ba327e2b0b8cf65527535d98.svg";
export { ForwardRef as ReactComponent };